import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/public_api';
import { StoreConfig } from 'ngx-web-api';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  constructor(private configService: ConfigService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentConfig: StoreConfig = this.configService.storeConfig.value;
    const token = currentConfig?.xsrfToken ?? null;

    const request = token ? req.clone({ setHeaders: { 'X-XSRF-TOKEN': token } }) : req;

    return next.handle(request);
  }
}
